import { render, staticRenderFns } from "./HelpToBuyIsaYN.vue?vue&type=template&id=2d29c177"
import script from "./HelpToBuyIsaYN.vue?vue&type=script&lang=js"
export * from "./HelpToBuyIsaYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports